import { useLocation, Navigate, Outlet } from 'react-router-dom';

import { AppLayout } from '@/app/layouts';
import { env } from '@/shared/config';
import { useAuthStore } from '@/store/auth';

export function ProtectedRoute() {
  const isAuthenticated = useAuthStore(
    (state) => env.authBypass || state.isAuthenticated
  );
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}

/** Same auth check, but renders the route bare — without AppLayout wrapper. */
export function BareProtectedRoute() {
  const isAuthenticated = useAuthStore(
    (state) => env.authBypass || state.isAuthenticated
  );
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
